import React, {useState, useEffect, useRef} from 'react'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {API_URL, ImagesUrl, ServerUrl, Token, config, schoolName} from '../component/include'
import { getClassField, getClassName} from '../component/globalFunction'
import { userToken } from '../component/authentication'

import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { Doughnut } from 'react-chartjs-2'
import {Bar, Line} from 'react-chartjs-2'

const ClassSummary = () => {
  const schoolInfo = useSelector(state => state.rootReducer.schoolInfo);

  const structure = useRef(null)
  const [notice, setNotice] = useState({
    isLoading: false, 
    isDataFetching: false,
  }); 
    
  const [allResult, setAllResult] = useState([])
  const [stat, setStat] = useState({
    male: 0,
    female: 0,
    total: 0
  })
  
  const handleFetchClass = () => {
    const fd = new FormData();
    fd.append('jwt', Token)
    let url = ServerUrl + '/fetchField/tbl_school_class/schoolClass/ID/1';
    axios.post(url, fd, config)
      .then(result => {
        let urls = API_URL+'/student/class_summary';
        axios.get(urls, config).then(response => {
          let sec = getAllSection(result.data)
          var final = sortResult(response.data.data, sec, result.data)
          if(final.length > 0) {
            var female = final.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue.female), 0)
            var male = final.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue.male), 0)

            setAllResult(final.sort((a, b) => (Number(a.order) > Number(b.order)) ? 1 : -1)) 
            setStat({
              female: female,
              male: male,
              total: male + female
            })
          }
        })
      })
      .catch((error) => Alerts('Error!', 'danger', JSON.stringify(error.message))) 
  }

  const getAllSection = (school) => {
    let section = []
    var newClass = [...school];
  
    for (var i in newClass) {
      if(newClass[i].section[0].sname === '') {   
        section.push({classID: newClass[i].ID, sectionID: newClass[i].ID})
      } else { 
        for(var k in newClass[i].section) {
          section.push({classID: newClass[i].ID, sectionID: newClass[i].section[k].ID})
        }
      } 
    } 
  
    return section
  }

  const sortResult = (data, section, classes) => {
    let result = []
    for(var k in section) {
      for(var i in data) {
        if(data[i].sectionID === section[k].sectionID) {
          result.push({
            label: String(getClassName(section[k].classID, section[k].sectionID, classes)), 
            male: data[i].Male, 
            female: data[i].Female, 
            total: Number(data[i].Male) + Number(data[i].Female), 
            order: getClassField(section[k].classID, classes, 'order')
          })
        }
      }
    }
    return result;
  }

  useEffect(() => {
    handleFetchClass()
  }, []);

  return (
    <>
      {notice.isLoading ? <LoadEffect className="overlay floatLoad" /> : "" }
      <div className="main-body">
        <div className="page-wrapper">
          {/* Page-header start */}
          <PageHeader title="Class Summary Report">
            <li className="breadcrumb-item"><a href="#!"> <i className="fa fa-fw fa-file-text"></i> </a></li>
            <li className="breadcrumb-item"><Link to="/students/view_students"> Students</Link></li> 
            <li className="breadcrumb-item"><a href="#!">Class Summary</a> </li>
          </PageHeader>
          {/* The Page Body start here */}
          <div className="page-body">
            <div className="card z-depth-0">
              <div className="card-block">
                <div className="row">
                  {schoolInfo && schoolInfo.map((st, id) => (
                    <div className="col-md-12" key={id}>
                      <div className="card border-0 shadow-sm mb-4">
                        <div className="card-body p-4">
                          <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                            <div className="d-flex align-items-center mb-3 mb-md-0">
                              <img 
                                id="viewSchoolLogo2" 
                                className="img-fluid rounded-circle shadow-sm mr-3" 
                                style={{width: '80px', height: '80px', objectFit: 'cover'}} 
                                onError={(e) => {e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} 
                                src={`${ImagesUrl}/about/${st.schoolLogo}`} 
                                title="School Logo" 
                                alt={st.schoolName} 
                              />
                              <div>
                                <h4 className="font-weight-bold mb-1">{st.schoolName}</h4>
                                <p className="text-muted mb-0"><em>Motto: {st.schoolMotto}</em></p>
                              </div>
                            </div>
                            <div className="text-md-right">
                              <p className="mb-1"><i className="feather icon-map-pin mr-2"></i>{st.address}</p>
                              <p className="mb-1"><i className="feather icon-phone mr-2"></i>{st.mobile} {st.altMobile && `, ${st.altMobile}`}</p>
                              <p className="mb-1"><i className="feather icon-mail mr-2"></i>{st.email}</p>
                              <p className="mb-0"><i className="feather icon-globe mr-2"></i>{st.website}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div> 
                <div className="row mb-4">
                  <div className="col-md-12">
                    <h5 className="text-center font-weight-bold mb-4">CLASS POPULATION SUMMARY</h5>
                  </div>
                </div>

                <div className="row mb-4">
                  {/* Total Students Card */}
                  <div className="col-lg-4 col-md-6 mb-3">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <h6 className="text-muted mb-0">TOTAL STUDENTS</h6>
                          <div className="bg-primary text-white rounded-circle p-2">
                            <i className="feather icon-users"></i>
                          </div>
                        </div>
                        <h2 className="font-weight-bold mb-0">{stat.total}</h2>
                        <p className="text-muted mb-0">Enrolled students</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Male Students Card */}
                  <div className="col-lg-4 col-md-6 mb-3">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <h6 className="text-muted mb-0">MALE STUDENTS</h6>
                          <div className="bg-info text-white rounded-circle p-2">
                            <i className="fa fa-male"></i>
                          </div>
                        </div>
                        <h2 className="font-weight-bold mb-0">{stat.male}</h2>
                        <p className="text-muted mb-0">{stat.total > 0 ? Math.round((stat.male / stat.total) * 100) : 0}% of total</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Female Students Card */}
                  <div className="col-lg-4 col-md-6 mb-3">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <h6 className="text-muted mb-0">FEMALE STUDENTS</h6>
                          <div className="bg-danger text-white rounded-circle p-2">
                            <i className="fa fa-female"></i>
                          </div>
                        </div>
                        <h2 className="font-weight-bold mb-0">{stat.female}</h2>
                        <p className="text-muted mb-0">{stat.total > 0 ? Math.round((stat.female / stat.total) * 100) : 0}% of total</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Gender Distribution Chart */}
                <div className="row mb-4">
                  <div className="col-lg-6 col-md-12 mb-3">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body">
                        <h6 className="text-muted mb-3">GENDER DISTRIBUTION</h6>
                        <div style={{ height: '250px', position: 'relative' }}>
                          {stat.total > 0 && (
                            <Doughnut 
                              data={{
                                labels: ['Male', 'Female'],
                                datasets: [{
                                  data: [stat.male, stat.female],
                                  backgroundColor: ['#36a2eb', '#ff6384'],
                                  borderWidth: 0
                                }]
                              }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  legend: {
                                    position: 'bottom'
                                  }
                                },
                                cutout: '70%'
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-lg-6 col-md-12 mb-3">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body">
                        <h6 className="text-muted mb-3">SUMMARY STATISTICS</h6>
                        <div className="table-responsive">
                          <table className="table table-borderless">
                            <tbody>
                              <tr>
                                <td>Total Students:</td>
                                <td className="font-weight-bold text-right">{stat.total}</td>
                              </tr>
                              <tr>
                                <td>Male Students:</td>
                                <td className="font-weight-bold text-right">{stat.male}</td>
                              </tr>
                              <tr>
                                <td>Female Students:</td>
                                <td className="font-weight-bold text-right">{stat.female}</td>
                              </tr>
                              <tr>
                                <td>Male to Female Ratio:</td>
                                <td className="font-weight-bold text-right">
                                  {stat.female > 0 ? (stat.male / stat.female).toFixed(2) : 'N/A'} : 1
                                </td>
                              </tr>
                              <tr>
                                <td>Classes with Students:</td>
                                <td className="font-weight-bold text-right">{allResult.length}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        <h6 className="text-muted mb-3">CLASS BREAKDOWN</h6>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead className="bg-light">
                              <tr>
                                <th className="border-top-0">SN</th>
                                <th className="border-top-0">Class</th>
                                <th className="border-top-0 text-center">Male</th>
                                <th className="border-top-0 text-center">Female</th>
                                <th className="border-top-0 text-center">Total</th>
                                <th className="border-top-0 text-center">Gender Ratio</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allResult.length !== 0 ? allResult.map((row, idx) => (
                                <tr key={idx}>
                                  <td>{idx+1}</td>
                                  <td><strong>{row.label}</strong></td>
                                  <td className="text-center">
                                    <span className="badge badge-info badge-pill px-3 py-2">{row.male}</span>
                                  </td>
                                  <td className="text-center">
                                    <span className="badge badge-danger badge-pill px-3 py-2">{row.female}</span>
                                  </td>
                                  <td className="text-center">
                                    <strong>{row.total}</strong>
                                  </td>
                                  <td className="text-center">
                                    <div className="progress" style={{height: '8px'}}>
                                      <div 
                                        className="progress-bar bg-info" 
                                        role="progressbar" 
                                        style={{width: `${row.total > 0 ? (row.male/row.total)*100 : 0}%`}} 
                                        aria-valuenow={row.total > 0 ? (row.male/row.total)*100 : 0} 
                                        aria-valuemin="0" 
                                        aria-valuemax="100"
                                      ></div>
                                      <div 
                                        className="progress-bar bg-danger" 
                                        role="progressbar" 
                                        style={{width: `${row.total > 0 ? (row.female/row.total)*100 : 0}%`}} 
                                        aria-valuenow={row.total > 0 ? (row.female/row.total)*100 : 0} 
                                        aria-valuemin="0" 
                                        aria-valuemax="100"
                                      ></div>
                                    </div>
                                  </td>
                                </tr>
                              )) : <tr><td colSpan="6"><TableLoader /></td></tr>}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div ref={structure} className="row mb-4 no-print">
                  <div className="col-md-12 d-flex justify-content-end">
                    <form method='POST' action={ServerUrl+'/printout/class_summary.php?token='+userToken} target='_blank'>
                      <input type='hidden' name='jwtToken' value={Token} />
                      <input type='hidden' name='allResult' value={JSON.stringify(allResult, null, 2)} />
                      <input type='hidden' name='stat' value={JSON.stringify(stat, null, 2)} />
                      <button type="submit" className="btn btn-primary shadow-sm">
                        <i className="fa fa-print mr-2"></i> Print Report
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(ClassSummary);
